import { ProviderTeam } from '@/types/provider-teams';

const mockTeams: ProviderTeam[] = [
  {
    id: 'team-uuid-1',
    name: 'Acme Corp',
    description: 'Main company team',
    slug: 'acme-corp',
    maxSeats: 10,
    status: 'active',
    createdAt: '2024-01-15T10:30:00Z',
    ownerCustomerId: 'customer-uuid-1',
  },
  {
    id: 'team-uuid-2',
    name: 'Marketing Agency',
    description: 'Agency partner team',
    slug: 'marketing-agency',
    maxSeats: 8,
    status: 'active',
    createdAt: '2024-01-20T10:30:00Z',
    ownerCustomerId: 'customer-uuid-4',
  },
  {
    id: 'team-uuid-3',
    name: 'GlobalCorp Engineering',
    description: 'Enterprise platform team',
    slug: 'globalcorp-engineering',
    maxSeats: 30,
    status: 'active',
    createdAt: '2023-08-25T09:00:00Z',
    ownerCustomerId: 'customer-uuid-3',
  },
  {
    id: 'team-uuid-4',
    name: 'Innovative Tech Solutions',
    description: 'Product experimentation team',
    slug: 'innovative-tech-solutions',
    maxSeats: 12,
    status: 'active',
    createdAt: '2024-03-15T11:15:00Z',
    ownerCustomerId: 'customer-uuid-4',
  },
  {
    id: 'team-uuid-5',
    name: 'DataDriven Analytics',
    description: 'Analytics & insights team',
    slug: 'datadriven-analytics',
    maxSeats: 5,
    status: 'inactive',
    createdAt: '2024-02-05T08:45:00Z',
    ownerCustomerId: 'customer-uuid-5',
  },
];

const toJsonApi = (team: ProviderTeam) => ({
  type: 'teams' as const,
  id: team.id,
  attributes: {
    name: team.name,
    description: team.description,
    slug: team.slug,
    max_seats: team.maxSeats,
    status: team.status,
    created_at: team.createdAt,
  },
  relationships: {
    owner: {
      data: {
        type: 'customers',
        id: team.ownerCustomerId,
      },
    },
  },
});

export const providerTeamOperations = {
  list: () => ({
    data: mockTeams.map(toJsonApi),
  }),
};
